import { SvgIconComponent } from '@mui/icons-material'
import { SvgIconTypeMap, styled } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid2 from '@mui/material/Grid2'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import Typography from '@mui/material/Typography'
import React from 'react'

import CustomTooltip from '@/app/component/atom/tooltip'

type SummaryBoxProps = {
  color?: React.ComponentProps<SvgIconComponent>['color']
  icon: OverridableComponent<SvgIconTypeMap> & { muiName: string }
  label: string
  tooltip?: string
  value: string | number
}

export default function SummaryBox({ icon: Icon, label, value, color = 'secondary', tooltip = '' }: SummaryBoxProps) {
  return (
    <Card>
      <CardContent>
        <Grid2 container>
          <Grid2 size={{ xs: 6 }}>
            <Container>
              <Icon
                fontSize="large"
                color={color}
                style={{
                  fontSize: '2.5rem',
                  color: 'rgba(0, 0, 0, 0.54)',
                }}
              />
              <CustomTooltip title={tooltip}>
                <Typography
                  variant="h5"
                  color="textSecondary"
                  sx={{
                    textAlign: 'center',
                    padding: (theme) => theme.spacing(2.5),
                  }}
                >
                  {label}
                </Typography>
              </CustomTooltip>
            </Container>
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <ValueContainer>
              <Typography
                variant="h5"
                color="primary"
                style={{
                  textAlign: 'right',
                }}
              >
                {value}
              </Typography>
            </ValueContainer>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  )
}

const Container = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
}))

const ValueContainer = styled(Container)(() => ({
  justifyContent: 'flex-end',
}))
